<template lang="pug">
    .layout
        Menu.menu(v-if="path != '/login' && path != '/mobile'")
        Nav.nav(v-if="path != '/login' && path != '/mobile'") {{path}}
        transition(name="slide-fade")
            router-view.content(:key="$route.fullPath")
</template>

<script>
import Menu from './components/menu.vue';
import Nav from './components/nav.vue';

export default {
    name: 'App',
    components: { Menu, Nav },
    data() {
        return {};
    },
    computed: {
        path() {
            return this.$route.path;
        },
    },
};
</script>
